import React, { ReactElement } from 'react';
import { Spinner, getDisplayName } from '@cp-shared-15/frontend-ui';

export type withLoadingHandlerProps = {
    isLoading: boolean;
    loadingPlacehloder?: ReactElement;
};

export const withLoadingHandler = <TProps extends Record<string, unknown>>(
    WrappedComponent: React.ComponentType<TProps>,
): React.FC<TProps & withLoadingHandlerProps> => {
    const Wrapper: React.FC<TProps & withLoadingHandlerProps> = ({
        isLoading,
        loadingPlacehloder,
        ...props
    }: withLoadingHandlerProps) =>
        isLoading ? loadingPlacehloder || <Spinner center={true} /> : <WrappedComponent {...(props as TProps)} />;

    Wrapper.displayName = `withLoadingHandler(${getDisplayName(WrappedComponent)})`;

    return Wrapper;
};
